

const contact_tr ={
    title: "Bizimle İletişime Geçin",
    text:"Projeniz, bakım talebiniz veya teknik sorularınız için bizimle iletişime geçin. Uzman ekibimiz en kısa sürede size dönüş sağlayacaktır.",
    hours_text:"Çalışma Saatleri",
    work_hours:"Pzt-Cum ",
    address:"Adres",
    email:"E-Posta",
    job_text: "İş fırsatları",
    form_fname:"Ad Soyad",
    form_tel:"Telefon",
    form_email:"E-posta",
    form_subject:"Konu",
    form_msg:"Mesaj", 
    buton: "Gonder",
    is_Senden_msg: 'Mail Gonderildi',
    subject_laser: "Lazer Kesim Talebi",
    subject_machining: "Talaşlı İmalat Talebi",
    body_template_laser:"Merhabalar, Lazer Kesim hakkında bilgi almak istiyorum.",
    body_template_machining:"Merhabalar, Talaşlı İmalat hakkında bilgi almak istiyorum.",
    other: "Diğer"
}


const contact_en ={
    title: "Get in Touch with us",
    text: "Contact us for your project inquiries, maintenance requests, or technical questions. Our expert team will get back to you as soon as possible.",
    hours_text:"Working Hours",
    work_hours:"Mon-Fri ",
    address:"Address",
    email:"Email",
    job_text: "Job opportunities",
    form_fname:"Full Name",
    form_tel:"Phone",
    form_email:"Email",
    form_subject:"Subject",
    form_msg:"Message",
    buton: "Send",
    is_Senden_msg: 'Mail Sent',
    subject_laser: "Laser Cutting Inquiry",
    subject_machining: "Machining Inquiry",
    body_template_laser:"Hello, I would like to get information about Laser Cutting.",
    body_template_machining:"Hello, I would like to get information about Machining.",
    other: "Other"
}


module.exports = { contact_tr, contact_en }




